import { Card } from "@f2e/ui/components/base"
import {
  ClientChannelType,
  InstagramClientConfig,
  MessengerClientConfig,
} from "@/types"
import { MetaConnectionData, MetaConnectionForm } from "../meta"

export interface MetaConfigFieldsProps {
  channelType: ClientChannelType.MESSENGER | ClientChannelType.INSTAGRAM
  config: MessengerClientConfig | InstagramClientConfig
  channelId: string
  workspaceId: string
  organizationId: string
  onConfigChange?: (
    config: Partial<MessengerClientConfig> | Partial<InstagramClientConfig>
  ) => void
  onSave?: (config: MessengerClientConfig | InstagramClientConfig) => void
  isLoading?: boolean
  onDirtyChange?: (isDirty: boolean) => void
}

export const MetaConfigFields = ({
  channelType,
  config,
  channelId,
  workspaceId,
  organizationId,
  onConfigChange,
  onSave,
  isLoading = false,
  onDirtyChange,
}: MetaConfigFieldsProps) => {
  const resourceId =
    channelType === ClientChannelType.MESSENGER
      ? (config as MessengerClientConfig).pageId
      : (config as InstagramClientConfig).accountId

  const handleSubmit = (data: MetaConnectionData) => {
    const updatedConfig =
      channelType === ClientChannelType.MESSENGER
        ? ({
            ...config,
            type: "messenger",
            pageId: data.resourceId,
            webhookVerifyToken: data.webhookVerifyToken,
            metaAppSecret: data.metaAppSecret,
            accessToken: data.accessToken,
            agentId: data.agentId,
            conversationSessionTimeoutHours:
              data.conversationSessionTimeoutHours,
          } as MessengerClientConfig)
        : ({
            ...config,
            type: "instagram",
            accountId: data.resourceId,
            webhookVerifyToken: data.webhookVerifyToken,
            metaAppSecret: data.metaAppSecret,
            accessToken: data.accessToken,
            agentId: data.agentId,
            conversationSessionTimeoutHours:
              data.conversationSessionTimeoutHours,
          } as InstagramClientConfig)

    onConfigChange?.(updatedConfig)
    onSave?.(updatedConfig)
  }

  return (
    <Card className="p-6">
      <MetaConnectionForm
        service={channelType}
        channelId={channelId}
        workspaceId={workspaceId}
        organizationId={organizationId}
        initialData={{
          resourceId,
          webhookVerifyToken: config.webhookVerifyToken,
          metaAppSecret: config.metaAppSecret,
          accessToken: config.accessToken,
          agentId: config.agentId,
          conversationSessionTimeoutHours:
            config.conversationSessionTimeoutHours,
        }}
        onSubmit={handleSubmit}
        isLoading={isLoading}
        onDirtyChange={onDirtyChange}
      />
    </Card>
  )
}

export default MetaConfigFields
